<script>
  import options from './GroupSearchResult.options'
  export default options
</script>

<template>
  <article class="kb-group-search-result" v-show="displaySearchResults">
    <div class="kb-general-search__meta-top-container">
      <div class="kb-general-search__results__result-number">{{ totalAmount }} {{ getLabel('resultCountTitle') }}</div>
      <div class="kb-group-search-result__cta">
        <a v-if="isNotCancerforum && getLabel('ctaLink')" class="kb-button kb-button--full-color-spot" :href="getLabel('ctaLink')">{{ getLabel('ctaLinkText') }}</a>
      </div>
    </div>
    <ul class="kb-group-search-result__list kb-list-results kb-list-results--grid-3col" >

      <template v-for="result, index in results" :key="index">
        <template v-if="spotCard && spotCard.position === index + 1">
            <li class="kb-active-groups__list-item">
              <SpotCardGrid :spotCardData="spotCard" /> 
            </li>
          </template>   

        <li class="kb-group-search-result__list">
          <GroupCard :content="result" :key="result.id"/>
        </li>
      </template>

      <template v-if="spotCard && spotCard.position > results.length">
        <li class="kb-active-groups__list-item">
          <SpotCardGrid :spotCardData="spotCard" /> 
        </li>
      </template>   
    </ul>


    <div class="kb-general-search__more-results" v-if="results.length > 0">
      <span class="kb-general-search__more-results__text" aria-live="polite">
        {{ getLabel('resultOutForTitle', [results.length, totalAmount]) }}
      </span>
      <template v-if="results.length < totalAmount">
        <button
          v-on:click="() => getMoreResults()"
          @keydown.enter.prevent="getMoreResults(true)"
          class="kb-button kb-button--full-color"
        >
          {{ getLabel('showMoreButtonText') }}
        </button>
      </template>
    </div>
    <template v-if="!resultCount && !showSpinner">
      <div class="kb-general-search__no-results">
        <h2>{{ getLabel('noResultTitle') }}</h2>
        <p class="kb-general-search__no-results__summary">
          {{ getLabel('noResultDesc') }}
        </p>
        <a v-if="isNotCancerforum"
          :href="getLabel('noResultButtonHref')"
          class="kb-button kb-button--full-color-spot"
          >{{ getLabel('noResultButtonText') }}</a
        >
      </div>
    </template>

    <div v-if="showSpinner" class="kb-spinner-overlay">
      <div class="kb-spinner-overlay__spinner"></div>
    </div>

  </article>
</template>
